import { type BubbleRoleDto } from "@crowdcoursing/api/openapi";

/** Matches API <c>RoleConstants.Admin</c> ("Admin"). */
const ADMIN_ROLE = "Admin";

/** Bubble IDs where the user has the Admin role (from whoami `bubbleRoles`). */
export function getAdminBubbleIds(bubbleRoles: BubbleRoleDto[] | null | undefined): string[] {
  return (bubbleRoles ?? []).flatMap((entry) => (entry.role === ADMIN_ROLE && entry.bubbleId ? [entry.bubbleId] : []));
}

/** True when the user has the Admin role on the given bubble. */
export function isAdminOfBubble(
  bubbleRoles: BubbleRoleDto[] | null | undefined,
  bubbleId: string | undefined,
): boolean {
  return Boolean(bubbleId && getAdminBubbleIds(bubbleRoles).includes(bubbleId));
}
